import { logAndNotifyError } from "../modules/logger";
import Notify from "devextreme/ui/notify";
import { HtmlEditor, Item, MediaResizing, Toolbar } from "devextreme-react/html-editor";
import { useCallback, useEffect, useRef, useState } from "react";
import { get, post } from "../modules/server";
import { Alert, Row } from "react-bootstrap";
import { EventInfo } from "devextreme/events";
import dxHtmlEditor from "devextreme/ui/html_editor";
import { List } from "devextreme-react";
import { useForm } from "react-hook-form";
import DataSource from "devextreme/data/data_source";
import SelectEditor from "../components/Global/Editors/SelectEditor";

interface IMutableRef {
  instance?: dxHtmlEditor;
}

const AdminSystemTexts = () => {
  const [text, setText] = useState({ id: "", title: "", body: "", groupName: "" });

  const [systemTextDataSource, setSystemTextDataSource] = useState<any>([]);
  const [systemTexts, setSystemTexts] = useState<any>([]);
  const [systemTextGroups, setSystemTextGroups] = useState<any>([]);
  const [stTextGroup, setStTextGroup] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [hasChanged, setHasChanged] = useState(false);
  const formHook = useForm();
  const { handleSubmit } = formHook;

  const onChangeTitle = (e: any) => {
    setTitle(e.target.value);
    setHasChanged(true);
  };

  useEffect(() => {
    fetchSystemTextList();
  }, []);

  const def: IMutableRef = { instance: undefined };
  const selfref = useRef(def);

  const textGroup = formHook.watch("textGroup");
  if (textGroup !== stTextGroup) {
    setStTextGroup(textGroup);

    const ds = new DataSource({
      store: textGroup === "Alla" ? systemTexts : systemTexts.filter((st: any) => st.groupName === textGroup),
      paginate: false,
    });
    setSystemTextDataSource(ds);
  }

  const fetchSystemTextList = async () => {
    var result = await get("GetSystemTextList");

    //Create a datasource explicitly. Using a Datasource is necessary for the "Search" functions to work and we don't want to have the list paginated...
    const ds = new DataSource({
      store: result.systemTexts,
      paginate: false,
    });
    setSystemTexts(result.systemTexts);
    setSystemTextDataSource(ds);
    const groups = result.systemTexts.reduce(
      (acc: any, cur: any) => {
        if (!acc.includes(cur.groupName)) acc.push(cur.groupName);
        return acc;
      },
      ["Alla"]
    );

    setSystemTextGroups(groups);
  };

  const fetchMarkup = async (id: string) => {
    setIsLoading(true);
    var systemText = await get("GetSystemText/" + id);

    setText(systemText.text);
    setTitle(systemText.text.title);
    setIsLoading(false);
    setHasChanged(false);
  };

  const onSelectedItemsChange = (e: any) => {
    if (e && e.length) {
      const curHtml = selfref.current.instance?.option("value");
      if (curHtml !== undefined && (curHtml !== text.body || title !== text.title)) {
        Notify("Autosaving...");
        onSubmit(null);
      }
      fetchMarkup(e[0].id);
    }
  };

  const onSubmit = async (data: any) => {
    try {
      const newSystemText = { ...text, title, body: selfref.current.instance?.option("value") };
      var result = await post("SaveSystemText", newSystemText);
      setHasChanged(false);
      fetchSystemTextList();
      if (result.success) {
        if (newSystemText.groupName === "Beräkningsflikar") {
          //Refresh cache for Beräkningsflikar immediatly
          PubSub.publish("RefreshBFLInfo");
        }
        Notify("Texten har sparats", "success");
      } else logAndNotifyError(result.message);
    } catch (err) {
      Notify(err, "error");
    }
  };

  const onCancel = () => {
    fetchMarkup(text.id.toString());
  };

  const onTest = () => {
    if (text) PubSub.publish("ShowHelp", text.id);
  };

  // const sizeValues = ["8pt", "10pt", "12pt", "14pt", "18pt", "24pt", "36pt"];
  const fontValues = ["Arial", "Georgia", "Tahoma", "Times New Roman", "Poppins", "Verdana"];
  const headerValues = [false, 1, 2, 3, 4, 5];

  const onContentReady = (e: EventInfo<dxHtmlEditor>) => {
    selfref.current.instance = e.component;
  };
  const onHtmlChanged = useCallback((e: any) => {
    setHasChanged(true);
  }, []);

  return (
    <>
      <Alert variant="primary">
        <h2 className="">Redigera systemtexter</h2>
      </Alert>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row className="gl-5">
          <div className="col-lg-2 pe-1 border-end  border-primary">
            {/* <select className="form-select" aria-label="Default select example">
              <option selected>Välj text</option>
              <option value="1">Text 1</option>
              <option value="2">Text 2</option>
              <option value="3">Text 3</option>
            </select> */}
            <SelectEditor label="Visa texter i grupp" fieldName="textGroup" formHook={formHook} items={systemTextGroups} />
            <hr></hr>
            <List
              height={700}
              searchEnabled={true}
              searchExpr={["id", "title", "body", "groupName"]}
              selectionMode="single"
              dataSource={systemTextDataSource}
              displayExpr="id"
              onSelectedItemsChange={onSelectedItemsChange}
            ></List>
          </div>

          <div className="col-lg-10">
            {isLoading && <div>Loading...</div>}
            {!isLoading && text.id && (
              <div>
                <div className="mb-3 input-group has-validation"></div>
                <div>
                  <div className="mb-3 input-group has-validation">
                    <label className="form-label w-100">
                      Titel
                      <div className={false ? "input-group" : ""}>
                        <input id="title" type="text" required={true} value={title} onChange={onChangeTitle} className={"form-control " + (!title ? "is-invalid" : "")} />
                        {!title && <div className="invalid-feedback">"Titel måste anges"</div>}
                      </div>
                    </label>
                  </div>
                  <HtmlEditor valueType="html" defaultValue={text.body} onContentReady={onContentReady} className="HtmlEditor" onValueChanged={onHtmlChanged}>
                    <Toolbar multiline={true}>
                      <Item name="undo" />
                      <Item name="redo" />
                      <Item name="separator" />
                      <Item name="header" acceptedValues={headerValues} />
                      <Item name="separator" />
                      <Item name="clear" />
                      {/* <Item name="codeBlock" />
                    <Item name="blockquote" /> */}
                      <Item name="separator" />
                      {/* <Item name="size" acceptedValues={sizeValues} /> */}
                      <Item name="font" acceptedValues={fontValues} />
                      <Item name="separator" />
                      <Item name="bold" />
                      <Item name="italic" />
                      <Item name="strike" />
                      <Item name="underline" />
                      <Item name="separator" />
                      <Item name="alignLeft" />
                      <Item name="alignCenter" />
                      <Item name="alignRight" />
                      <Item name="alignJustify" />
                      <Item name="separator" />
                      <Item name="orderedList" />
                      <Item name="bulletList" />
                      <Item name="separator" />

                      {/* <Item name="color" />
                    <Item name="background" />
                    <Item name="separator" /> */}
                      <Item name="link" />
                      <Item name="image" />
                      <Item name="separator" />

                      <Item name="insertTable" />
                      <Item name="deleteTable" />
                      <Item name="insertRowAbove" />
                      <Item name="insertRowBelow" />
                      <Item name="deleteRow" />
                      <Item name="insertColumnLeft" />
                      <Item name="insertColumnRight" />
                      <Item name="deleteColumn" />
                      <Item name="cellProperties" />
                      <Item name="tableProperties" />
                    </Toolbar>
                    <MediaResizing enabled={true} />
                  </HtmlEditor>
                </div>

                <div className="d-grid gap-2 d-md-flex justify-content-md-end mt-3">
                  <div style={{ paddingRight: 12, paddingLeft: 4 }}>
                    {/* {hasChanged ? <>*</> : <></>} */}
                    <button type="button" className="btn btn-secondary ms-2" disabled={hasChanged} onClick={onTest}>
                      Test
                    </button>
                    <button type="button" className="btn btn-secondary ms-2" onClick={onCancel}>
                      Avbryt
                    </button>
                    <button type="submit" className="btn btn-primary ms-2">
                      Spara {hasChanged ? " *" : ""}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Row>
      </form>
    </>
  );
};

export default AdminSystemTexts;
